import operationTypes from 'constants/operationTypes';

export const operationList = [
  'ALL',
  operationTypes.SELL_PARTICIPATION,
  operationTypes.HERITAGE,
  operationTypes.DONATION,
  operationTypes.ENDORSEMENT,
  operationTypes.TRANSMISSION,
  operationTypes.CONSTITUTION,
  operationTypes.CAPITAL_INCREASE,
  operationTypes.CAPITAL_DECREASE,
  operationTypes.SPLIT,
  operationTypes.RENUMERATION,
  operationTypes.RECLASSIFICATION,
  operationTypes.DIVIDENDS_DISTRIBUTION,
];
